module.exports = __webpack_public_path__ + "static/media/avatars_all_35.80be03ac.png";